import { BaseResource } from 'utils/ApiUtils';

export default class Inspection extends BaseResource {
  constructor(args) {
    super(args, Inspection.attributes);
  };


  static columns = [
    { title: "Resource", field: "Name_SystemUser_Rassignment", type: "string" },
    { title: "Manager", field: "Name_ManagerAssignment_Rassignment", type: "string"},
    { title: "Status", field: "Description_InspectionStatus", type: "string" },
    {
      title: "Inspector Tracking Date",
      field: "OccurenceDate_InspectorTracking",
      type: "date",
      filter: true,
      sorting: true,
      render: rowData => {
          if (!rowData.OccurenceDate_InspectorTracking) return '';
          return new Date(rowData.OccurenceDate_InspectorTracking).toLocaleDateString('en-US', { timeZone: 'UTC' });
      }
    },
    { title: "Date Entered", field: "DateEntered", type: "date", defaultSort: "desc" },
    { title: "Date Completed", field: "DateCompleted", type: "date" },
    { title: "Last Updated", field: "LastUpdateDate", type: "date" },
    { title: "Inspection Number", field: "InspectionNumber", sorting: true, type: "string" },
    { title: "Inspection Id", field: "InspectionId", sorting: false, type: "string", hidden: true },
    { title: "QC Name", field: "Name_SystemUser_Qcresource", sorting: true, type: "string", hidden: false },
    { title: "Comments", field: "Comments", sorting: false, type: "boolean", hidden: false },
    { title: "QC Comments", field: "QcComments", sorting: false, type: "string", hidden: true },
    
  ]
  static attributes = Inspection.columns.map(r => r.field);

  static expand = [
    { "Rassignment": { "expand": [{ "SystemUser": { select: ["Name"] }},  {'ManagerAssignment': { select: ['Name'] }}] }},
    { "Qcresource": { "expand": [{ "SystemUser": { select: ["Name"] }}] }},
    { "InspectionStatus": { "select": ["Description"] } },
    {
      "InspHasWorkitem": {
        "expand": [
          {
            "InspectorTracking": { select: ["OccurenceDate"], top: 1, orderBy: "OccurenceDate asc" }
          }]
      }
    }
  ];

};